import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

export interface Props {
  employeeName: string
  date: string
}

const BasicInformation = ({ employeeName, date }: Props) => {
  return (
    <Box
      borderRadius={{ all: 'abs008' }}
      padding="s16"
      gap="s12"
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      background="grey100"
    >
      <Box flexDirection="row" gap="s8">
        <Icon.Medium icon="person" color="grey700" />

        <Text.Normal size="300" color="grey1000">
          {employeeName}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" gap="s8">
        <Icon.Medium icon="calendar" color="grey700" />

        <Text.Normal size="300" color="grey1000">
          {date}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(BasicInformation)
